import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Axios from 'axios';
import { Uris } from '../../common/constants';

@Component
class HeaderNotificationsItem extends Vue {

  @Prop({ required: true, type: [Number] })
  id: string
  @Prop({ required: false, type: [String] })
  name: string
  @Prop({ required: false, type: [String, Object] })
  avatar: string | { [key: string]: any }
  @Prop({ required: false, type: [String] })
  createdDate: string
  @Prop({ required: true, type: [String] })
  redirectTo: string
  @Prop({ required: true, type: [String] })
  colorClass: string
  @Prop({ required: true, type: [String] })
  textColorClass: string
  @Prop({ default: null, required: false, type: [String] })
  avatarUrl?: string
  @Prop({ default: null, required: false, type: [String] })
  avatarText?: string
  @Prop({ required: true, type: [String] })
  message: string
  @Prop({ required: true, type: [String] })
  subInfo: string


  handleOnClick(event) {
    Axios.patch(Uris.Notification, { notificationId: this.id })
      .then(res => {
        this.$emit("click", this.redirectTo)
      })
      .catch(err => console.log(err))
  }
}

export default HeaderNotificationsItem;


// WEBPACK FOOTER //
// ./src/components/header-notifications-item/index.ts